import axios from "axios";


const API = axios.create({
  baseURL: "https://codezilla115.app.n8n.cloud/webhook",
});

export const sendAIMessage = async (message) => {
  const res = await API.post("/chat", {chatInput: message ,sessionId: localStorage.getItem("chatSessionId"),type:'text'});
  return res.data;
};

export const uploadVoice = async (audioBlob) => {
  const formData = new FormData();
  formData.append("audio", audioBlob, "voice_message.webm");
  formData.append("sessionId", localStorage.getItem("chatSessionId"));
  formData.append("type",'audio');
  const res = await API.post("/chat", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
